<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pt-0 pb-3 px-3">


          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>{{ display_text }}</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn class="primary" small fab @click="addNewRecord_onClick()" v-on="on">
                          <v-icon>add_circle_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Submit {{ display_text }}</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex xs12>

                        <v-expansion-panel>
                          <v-expansion-panel-content class="accent">
                            <template v-slot:header>
                              <div style="font-size: medium;">Filter Panel</div>
                            </template>

                            <v-container class="pt-0">
                              <v-layout row wrap>
                                <v-flex class="text-xs-right">
                                  <v-btn color="orange" small fab @click="selected_filter.push({field:'',value:''})"><v-icon color="white">add</v-icon></v-btn>
                                  <v-btn color="green" @click="refreshData()">GENERATE NOW</v-btn>
                                  <v-btn color="cyan lighten-1" @click="selected_filter=[], refreshData()">RESET FILTER</v-btn>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex>
                                  <v-card>
                                    <v-card-text v-if="selected_filter.length > 0">
                                      <v-container>
                                        <v-layout row wrap
                                          v-for="(item,i) in selected_filter"
                                          :key="i"
                                        >
                                          <v-flex xs12 md5>
                                            <v-select
                                              v-model="selected_filter[i].field"
                                              :items="get_filterable_columns"
                                              clearable
                                              item-text="text"
                                              item-value="value"
                                              label="select field"
                                            ></v-select>
                                          </v-flex>
                                          <v-flex xs12 md1 class="text-md-center">
                                            contains
                                          </v-flex>
                                          <v-flex xs12 md5>
                                            <v-text-field
                                              v-model="selected_filter[i].value"
                                              label="your text"
                                            ></v-text-field>
                                          </v-flex>
                                          <v-flex xs12 md1>
                                            <v-layout justify-space-around class="mb-2">
                                              <span class="group pa-2">
                                                <v-btn color="red" small fab @click="selected_filter.splice(i,1)" :disabled="false"><v-icon color="white">clear</v-icon></v-btn>

                                              </span>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                      </v-container>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>

                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-data-table
                          id="appraisal_table_id"
                          ref="appraisal_table_ref"
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          must-sort
                          :pagination.sync="table_setting.pagination"
                          :rows-per-page-items="table_setting.rows_per_page_items"
                          :total-items="table_setting.pagination.totalItems"
                          class="elevation-1"
                        >
                          <v-progress-linear color="blue" indeterminate>
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item.year }}</td>
                            <td class="pa-1">{{ props.item.qtr }}</td>
                            <td class="pa-1">{{ props.item.hub }}</td>
                            <td class="pa-1">{{ props.item.department }}</td>
                            <td class="pa-1">{{ props.item.revision }}</td>
                            <td class="pa-1">{{ props.item.username }}</td>
                            <td class="pa-1">
                              {{
                              convert_2_locale_datetime(props.item.created)
                              }}
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>

</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
import comm from "../../functions/communication.api";
// import qb from "../../functions/query.builder";

export default {
  name: "myVoiceTableListing",
  // components: {
  //   PageLayout: PageLayout,
  // },
  data() {
    return {
      username: "",
      // pageID: "",
      pageUUID: "",
      // form_id: "",
      form_name: "",
      addNew_path: "",
      display_text: "",
      return_page: "",
      new_filter: {
        condition: "and",
        rules: []
      },
      showMenu: false,
      view_record: false,
      filters_setting: {
        filter_row: 0,
      },
      my_filter: {
        field: "",
        value: "",
      },
      selected_filter: [],
      table_setting: {
        loading: false,
        rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [
          {
            text: "Year",
            value: "year",
            class: "pa-1 pl-3",
            filterable: true,
            sortable: true,
            data_type: String
          },
          {
            text: "Qtr",
            class: "pa-1",
            value: "qtr",
            filterable: true,
            sortable: true,
            data_type: String
          },
          {
            text: "Hub",
            class: "pa-1",
            value: "hub",
            filterable: true,
            data_type: String
          },
          {
            text: "Department",
            class: "pa-1",
            value: "department",
            filterable: true,
            data_type: String
          },
          {
            text: "Rev",
            align: "left",
            class: "pa-1",
            value: "revision",
            filterable: false,
            data_type: Number
          },
          {
            text: "Created By",
            align: "left",
            class: "pa-1",
            value: "username",
            filterable: false,
            data_type: String
          },
          {
            text: "Created DateTime",
            align: "left",
            class: "pa-1",
            value: "created",
            filterable: false,
            data_type: String
          }
        ],
        records: [],
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 10,
          sortBy: "created",
          totalItems: 0
        }
      },
      status_option: [],
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    },
  },
  mounted() {
    let self = this;

    self.username = auth.getUsername();
    
    // self.pageID = common.App.get_pageID();
    // var menu = auth.getMenu().concat(auth.getMenu_int());
    // var pageCurrent = menu.filter(function(AppMenu) {
    //   return AppMenu.id == self.pageID;
    // });
    
    self.pageUUID = common.App.get_pageUUID();
    var menu = auth.getMenu().concat(auth.getMenu_int());
    var pageCurrent = menu.filter(function(AppMenu) {
      return AppMenu.uuid == self.pageUUID;
    });

    self.form_name = pageCurrent[0].component_path.form_name;
    self.addNew_path = pageCurrent[0].component_path.addNew_path;
    self.display_text = pageCurrent[0].display_text;
    
  },
  created (){
    // auth.hideHeader(true);
  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },

    async refreshData() {

      var sorting = [
        // {sortBy: "year", descending: true},
        // {sortBy: "qtr", descending: true},
      ];

      sorting.push({
        sortBy: this.table_setting.pagination.sortBy,
        descending: this.table_setting.pagination.descending
      });

      var sort_el = "";

      for (var m in sorting) {
        sort_el += " , j." + sorting[m].sortBy + (sorting[m].descending?' desc':' asc');
      }
      var substr_pos1 = 2;
      var sort_el_length = sort_el.length;
      sort_el = sort_el.substr(substr_pos1, sort_el_length - substr_pos1); // to remove , of first sorting element
      var str1 = " sort";
      sort_el = str1.concat(sort_el);


      var filter_el = "";
      if (this.selected_filter.length > 0) {
        var temp_filter = this.selected_filter;

        for (var i in temp_filter) {
          filter_el += ' && like(j.' + temp_filter[i].field + ', "%' + temp_filter[i].value + '%", true)';
        }

        var substr_pos = 3;
        var filter_el_length = filter_el.length;
        filter_el = filter_el.substr(substr_pos, filter_el_length - substr_pos); // to remove && of first filter element
        var str2 = " filter";
        filter_el = str2.concat(filter_el);
      }

      var q_return = [
        '{"year":rec.submission.data.year' ,
        ' "qtr":rec.submission.data.quarter' ,
        ' "username":rec.submission.data.username' ,
        ' "hub":rec.submission.data.hub' ,
        ' "department":rec.submission.data.department' ,
        ' "created":rec.created_datetime' ,
        ' "data_id":rec._id' ,
        ' "form_name":rec.form_name' ,
        ' "revision":form.revision}']

      q_return = q_return.join();


      var q_record_base = [
        'let records_base = (for form in forms filter contains(form.name,"',
        this.form_name,
        '") for rec in form_datas filter contains(rec.form_id,form._id) && like(rec.submission.data.username,"%',
        this.username,
        '%", true) return ',
        q_return,
        ') '
      ];
      
      q_record_base = q_record_base.join("");
      

      var temp_pagination = (this.table_setting.pagination.page-1) * this.table_setting.pagination.rowsPerPage;

      var q_record = [
        q_record_base +
        'let records_all = (for j in records_base',
        filter_el,
        sort_el,
        ' return j) let records = (for m in records_all limit ',
        temp_pagination,
        ',',
        this.table_setting.pagination.rowsPerPage,
        ' return m) let Tcount = count(for k in records_all return 1) return {"totalItems":Tcount, "records":records}'
      ];

      q_record = q_record.join("");

      var results = await comm.getFormData(q_record)
      this.table_setting.records = results.data[0].records;
      this.table_setting.pagination.totalItems = results.data[0].totalItems;
    },

    addNewRecord_onClick() {
      this.$router.push ({
        path: this.addNew_path, // + "&pageid=" + this.pageID,
        query: {
          display_text: this.display_text,
          // form_id: this.form_id,
          form_name: this.form_name,
          // return_page: this.$route.query.return_page,
          // pageid: this.pageID,
          uuid: this.pageUUID
          // addNew_path: this.addNew_path
        }
      });
    },
    viewMenu() {
      this.showMenu = true;
    },
    // main_menu_onClick(action_name) {
    //   this.$router.push({ name: action_name });
    // },
    save_onClick() {
      // let self = this;

      // this.$validator.validateAll().then(async result => {
      //   if (result) {
      //     let result = await common.wBackEndComm.PostData(
      //       "company/crud_company/",
      //       self.selected
      //     );

      //     if (result.data.Status == 1) {
      //       self.dialog.visible = false;
      //       self.refreshData();
      //       common.wMsgBox.Success(result.data.Description);
      //     } else {
      //       common.wMsgBox.Error(result.data.Description);
      //     }
      //   }
      // });
    },

    onClick_breadcrumb(data) {
      // console.log("data",data);
      var method = data.method__class_name + "-" + data.method__column_name + "-" + data.method__key;
      // common.App.update_pageID(data.id);

      switch(method) {
        case "Page-method-1":
          window.open(data.path);
          break;
          
        // case "Page-method-3":
        //   this.dialog.visible = true;
        //   this.dialog.iframe_url = data.component_path.iframe_path;
        //   break;

        default:
          // this.router_props = {
          //   // form_id: card.component_path.form_id,
          //   form_name: data.component_path.form_name,
          //   addNew_path: data.component_path.addNew_path,
          //   display_text: data.display_text,
          //   return_page: data.path  
          // };

          // this.router_props = data.component_path;
          // console.log("c",this.router_props);
          // this.$router.push({path: data.path, query: this.router_props});
          this.$router.push({ path: data.path });
          // this.initial();
          //window.location.reload();
      }
    },
  }
};
</script>

<style>

</style>
